import { ListItem, ListItemButton, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CarWithCostumer } from "../../../../entities/car/model/car";

interface CarListItemComponentProps {
  car: CarWithCostumer;
}

const CarListItemComponent = ({ car }: CarListItemComponentProps) => {
  const navigate = useNavigate();

  return (
    <ListItem key={car.id} divider>
      <ListItemButton
        onClick={() => navigate(`/cars/${car.id}/edit`)}
        role={undefined}
        dense
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-end",
          textAlign: "center"
        }}
      >
        <ListItemText id={`client-${car.id}`} primary={car.costumer?.name || "N/A"} sx={{ flex: "1" }} />
        <ListItemText id={`brand-${car.id}`} primary={car.brand || "N/A"} sx={{ flex: "1" }} />
        <ListItemText id={`model-${car.id}`} primary={car.model || "N/A"} sx={{ flex: "1" }} />
        <ListItemText id={`plate-${car.id}`} primary={car.plate || "N/A"} sx={{ flex: "1" }} />
        <ListItemText id={`chassis-${car.id}`} primary={car.chassis_number || "N/A"} sx={{ flex: "1" }} />
        <ListItemText
          id={`created-${car.id}`}
          primary={car.created_at ? new Date(car.created_at).toLocaleString("pt-br") : "N/A"}
          sx={{ flex: "1" }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export default CarListItemComponent;
